import { render, staticRenderFns } from "./MbFilm.vue?vue&type=template&id=8b626e8c&scoped=true&"
import script from "./MbFilm.vue?vue&type=script&lang=js&"
export * from "./MbFilm.vue?vue&type=script&lang=js&"
import style0 from "./MbFilm.vue?vue&type=style&index=0&id=8b626e8c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b626e8c",
  null
  
)

export default component.exports